import Link from 'components/link';

export const TermsLink = Link.withConfig({
  fontSize: 'md',
  isUnderlined: true,
});
